import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Example from "./components/FancyCounter";

ReactDOM.render(<Example />, document.getElementById("root"));
